import { render, staticRenderFns } from "./JournalMobileView.vue?vue&type=template&id=60a1a271&scoped=true&"
import script from "./JournalMobileView.vue?vue&type=script&lang=js&"
export * from "./JournalMobileView.vue?vue&type=script&lang=js&"
import style0 from "./JournalMobileView.vue?vue&type=style&index=0&id=60a1a271&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a1a271",
  null
  
)

export default component.exports